import { request, getBaseUrl, sessionFetch } from './http';

export async function getSharePointStatus() {
    return request('/sharepoint/status');
  }

export async function getSharePointCompanyResources(params = {}) {
    const qs = new URLSearchParams(params).toString();
    return request(`/sharepoint/admin/company-resources${qs ? `?${qs}` : ''}`);
  }

export async function getSharePointCompanyResource(id) {
    return request(`/sharepoint/admin/company-resources/${id}`);
  }

export async function createSharePointCompanyResource(payload) {
    return request('/sharepoint/admin/company-resources', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

export async function updateSharePointCompanyResource(id, payload) {
    return request(`/sharepoint/admin/company-resources/${id}`, {
      method: 'PUT',
      body: JSON.stringify(payload)
    });
  }

export async function deleteSharePointCompanyResource(id) {
    return request(`/sharepoint/admin/company-resources/${id}`, { method: 'DELETE' });
  }

export async function testSharePointConnection() {
    return request('/sharepoint/admin/test-connection', { method: 'POST' });
  }

export async function getSharePointDocuments(companyId, params = {}) {
    const qs = new URLSearchParams();
    if (params.subPath) qs.set('subPath', params.subPath);
    if (params.top) qs.set('top', params.top);
    const q = qs.toString();
    return request(`/sharepoint/companies/${companyId}/documents${q ? `?${q}` : ''}`);
  }

export async function getSharePointListItems(companyId, params = {}) {
    const qs = new URLSearchParams(params).toString();
    return request(`/sharepoint/companies/${companyId}/list-items${qs ? `?${qs}` : ''}`);
  }

export async function downloadSharePointDocument({ resourceMappingId, itemId, driveId, fileName }) {
    const qs = new URLSearchParams({
      resourceMappingId: String(resourceMappingId),
      itemId: String(itemId)
    });
    if (driveId) qs.set('driveId', driveId);
    if (fileName) qs.set('fileName', fileName);
    const url = `${getBaseUrl().replace(/\/+$/, '')}/api/sharepoint/documents/download?${qs.toString()}`;
    const response = await sessionFetch(url);
    if (!response.ok) {
      let message = `Download failed (${response.status})`;
      try {
        const data = await response.json();
        message = data.message || message;
      } catch {
        /* ignore */
      }
      throw new Error(message);
    }
    const blob = await response.blob();
    const downloadName = fileName || 'download';
    const objectUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = downloadName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(objectUrl);
  }

export const sharepointApi = {
  getSharePointStatus,
  getSharePointCompanyResources,
  getSharePointCompanyResource,
  createSharePointCompanyResource,
  updateSharePointCompanyResource,
  deleteSharePointCompanyResource,
  testSharePointConnection,
  getSharePointDocuments,
  getSharePointListItems,
  downloadSharePointDocument,
};

